import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "show-more d-flex justify-content-end align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitToggle = _resolveComponent("MrUiKitToggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MrUiKitToggle, {
      label: _ctx.t('common.showAll'),
      labelPosition: 'left',
      class: "toggle-custom",
      modelValue: _ctx.isToggle,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isToggle) = $event)),
      classes: ['custom-switch-competition']
    }, null, 8, ["label", "modelValue"])
  ]))
}